module.exports = __webpack_public_path__ + "img/yahoo_btn.834e9eeb.png";